export const MembershipIds = {
  TRANSFERRED: 'transferredPlan',
  ANNUAL: 'yearlyPlanC',
  MONTHLY: 'fightcampplanC',
  SIX_MONTHS: '6MonthsPlan5',
  GQ: 'GQfightcampplan',
  PT: 'partnerfightcampplan',
}